// extracted by mini-css-extract-plugin
module.exports = {"listMenu":"styles_listMenu__X8_2L","selected":"styles_selected__defpV","menu":"styles_menu__311NE","emoji":"styles_emoji__HyZCY"};